package anjuros.development.components.language

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import anjuros.development.util.Res

enum class Language(val code: String, val nativeName: String, val flag: String) {
    PL("pl", "Polski", flag = Res.Image.flag_poland),
    EN("en", "English", flag = Res.Image.flag_uk),
    SK("sk", "Slovak", flag = Res.Image.flag_slovak),
    RO("ro", "Română", flag = Res.Image.flag_romania),
    CS("cs", "Čeština", flag = Res.Image.flag_czech),
    HU("hu", "Magyar", flag = Res.Image.flag_hungary),
}

enum class ResKey {

    ADDRESS,
    SECTION_ROOMS,
    SECTION_NEARBY,
    SECTION_FACILITIES,
    SECTION_REVIEWS,
    SECTION_FAQ,
    SECTION_CONTACT,
    MAP_DIRECTION,
    BOOKING,
    ROOM1,
    ROOM1_DESC,
    ROOM2,
    ROOM2_DESC,
    ROOM3,
    ROOM3_DESC,

    REVIEW_BOOKING,
    REVIEW_GOOGLE,

    REVIEW1_DESC,
    REVIEW2_DESC,
    REVIEW3_DESC,
    REVIEW4_DESC,
    REVIEW5_DESC,
    REVIEW6_DESC,
    REVIEW7_DESC,
    REVIEW8_DESC,
    REVIEW9_DESC,
    REVIEW10_DESC,

    NEARBY1,
    NEARBY2,
    NEARBY3,

    FACILITY1,
    FACILITY2,
    FACILITY3,
    FACILITY4,
    FACILITY5,
    FACILITY6,
    FACILITY7,
    FACILITY8,
    FACILITY9,

    FAQ1_Q,
    FAQ1_A,
    FAQ2_Q,
    FAQ2_A,
    FAQ3_Q,
    FAQ3_A,
    FAQ4_Q,
    FAQ4_A,
    FAQ5_Q,
    FAQ5_A,

}


val TextResources = mapOf(
    Language.SK to mapOf(
        ResKey.ADDRESS to "8,5 km od Kotelnice v Bialke Tatrzańskej",
        ResKey.SECTION_ROOMS to "Izby",
        ResKey.SECTION_NEARBY to "Okolie",
        ResKey.SECTION_FACILITIES to "Vybavenie",
        ResKey.SECTION_REVIEWS to "Recenzie",
        ResKey.SECTION_FAQ to "FAQ",
        ResKey.SECTION_CONTACT to "Kontakt",
        ResKey.MAP_DIRECTION to "Zobraziť na mape",
        ResKey.BOOKING to "Rezervovať izbu",
        ResKey.ROOM1 to "Dvojlôžková izba s balkónom",
        ResKey.ROOM1_DESC to "Rozloha 17 m², 1 manželská posteľ. Balkón,\n" +
                "výhľad do záhrady,\n" +
                "súkromná kúpeľňa,\n" +
                "TV s plochou obrazovkou,\n" +
                "bezplatné Wi-Fi",
        ResKey.ROOM2 to "Trojlôžková izba s balkónom",
        ResKey.ROOM2_DESC to "Rozloha 19 m², 1 jednolôžková posteľ a 1 manželská posteľ. Balkón,\n" +
                "výhľad do záhrady,\n" +
                "súkromná kúpeľňa,\n" +
                "TV s plochou obrazovkou,\n" +
                "bezplatné Wi-Fi",
        ResKey.ROOM3 to "Štvorlôžková izba",
        ResKey.ROOM3_DESC to "Rozloha 22 m², 2 jednolôžkové postele a 1 manželská posteľ.\n" +
                "Výhľad do záhrady,\n" +
                "súkromná kúpeľňa,\n" +
                "TV s plochou obrazovkou,\n" +
                "bezplatné Wi-Fi",

        ResKey.REVIEW1_DESC to "Srdečne odporúčam toto miesto. Veľmi dobrá lokalita, približne 10 minút autom ku ski vlekám v Białke Tatrzańskej. Veľmi čistá izba a kúpeľňa, plus zdieľaná kuchyňa s kompletným vybavením. Majitelia boli veľmi milí a pozorní, dokonca nám ponúkli chutný domáci syr. Pripravené miesto na uskladnenie lyžiarskeho vybavenia. Toto miesto odporúčam!",
        ResKey.REVIEW2_DESC to "Je to jednoducho fantastické miesto s veľmi dobrou energiou majiteľov. Určite sa sem vrátime a odporúčame všetkým.",
        ResKey.REVIEW3_DESC to "Pokojné, útulné miesto na oddych. Odporúčam!",
        ResKey.REVIEW4_DESC to "Čisté, upratané, vynikajúci pomer ceny a kvality 😁…",
        ResKey.REVIEW5_DESC to "Super miesto na oddych. Blízko termálne kúpele a zjazdovky. Izby nové a čisté. Majitelia milí a ochotní. Odporúčam zo srdca a teším sa na ďalšiu návštevu.",
        ResKey.REVIEW6_DESC to "Nové, čisté izby v penzióne Skwarek. Dobre vybavená kuchyňa a veľmi príjemná atmosféra. Majitelia veľmi sympatickí, odporúčam.",
        ResKey.REVIEW7_DESC to "Ďakujeme pekne za pobyt. Strávili sme u vás nádherný čas. Izba čistá a uprataná. Kuchyňa priestranná a vybavená všetkými potrebnými spotrebičmi (mikrovlnka, chladnička, sporák atď.). Hostiteľka veľmi milá a ochotná ;)",
        ResKey.REVIEW8_DESC to "Veľmi odporúčam toto miesto. Veľmi pohostinná hostiteľka a prekvapivo vysoký štandard izieb. Prakticky všetko nové a voňavé. Horúco odporúčam!",
        ResKey.REVIEW9_DESC to "Dobrý deň, odporúčam ubytovanie u Skwarka. Milí majitelia a nové izby s kúpeľňami. Okrem toho dobre vybavená kuchyňa. Nowa Biała je pokojná obec v okolí Białky a Bukowiny Tatrzańskej. Blízko Tatier autom. Odporúčam.",
        ResKey.REVIEW10_DESC to "Skvelí hostitelia, výborné ubytovanie, krásne prostredie na turistiku a cyklotúry. Srdečne odporúčam ❤",
        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "google recenzie",

        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Termy Bania",
        ResKey.NEARBY3 to "Hrad Niedzica",

        ResKey.FACILITY1 to "Bezplatné parkovanie",
        ResKey.FACILITY2 to "Súkromná kúpeľňa",
        ResKey.FACILITY3 to "Bezplatné Wi-Fi",
        ResKey.FACILITY4 to "Rodinné izby",
        ResKey.FACILITY5 to "Spoločná kuchyňa",
        ResKey.FACILITY6 to "Miesto na ohnisko",
        ResKey.FACILITY7 to "Spoločenské hry / puzzle",
        ResKey.FACILITY8 to "Kúrenie",
        ResKey.FACILITY9 to "Záhradný nábytok",

        ResKey.FAQ1_Q to "Aké sú časy príchodu a odchodu v penzióne Skwarek?",
        ResKey.FAQ1_A to "Check-in začína o 16:00 a check-out je do 11:00.",
        ResKey.FAQ2_Q to "Je na mieste parkovanie?",
        ResKey.FAQ2_A to "Bezplatné súkromné parkovanie je k dispozícii na mieste (rezervácia nie je potrebná).",
        ResKey.FAQ3_Q to "Ako ďaleko je Penzión Skwarek od lyžiarskeho strediska Kotelnica?",
        ResKey.FAQ3_A to "Penzión Skwarek je vzdialený 8,5 km od lyžiarskeho strediska Kotelnica.",
        ResKey.FAQ4_Q to "Je na mieste reštaurácia?",
        ResKey.FAQ4_A to "Bohužiaľ, v penzióne Skwarek nie je reštaurácia.",
        ResKey.FAQ5_Q to "Môžem prísť so zvieraťom?",
        ResKey.FAQ5_A to "Zviera nie je povolené v penzióne Skwarek."
    ),


    Language.EN to mapOf(
        ResKey.ADDRESS to "8.5 km from Kotelnica in Białka Tatrzańska",
        ResKey.SECTION_ROOMS to "Rooms",
        ResKey.SECTION_NEARBY to "Nearby",
        ResKey.SECTION_FACILITIES to "Facilities",
        ResKey.SECTION_REVIEWS to "Reviews",
        ResKey.SECTION_FAQ to "FAQ",
        ResKey.SECTION_CONTACT to "Contact",
        ResKey.MAP_DIRECTION to "View on map",
        ResKey.BOOKING to "Book a room",
        ResKey.ROOM1 to "Double room with balcony",
        ResKey.ROOM1_DESC to "Area 17 m², 1 double bed. Balcony,\n" +
                "garden view,\n" +
                "private bathroom,\n" +
                "flat-screen TV,\n" +
                "free Wi-Fi",
        ResKey.ROOM2 to "Triple room with balcony",
        ResKey.ROOM2_DESC to "Area 19 m², 1 single bed and 1 double bed. Balcony,\n" +
                "garden view,\n" +
                "private bathroom,\n" +
                "flat-screen TV,\n" +
                "free Wi-Fi",
        ResKey.ROOM3 to "Quadruple room",
        ResKey.ROOM3_DESC to "Area 22 m², 2 single beds and 1 double bed. " +
                "Garden view,\n" +
                "private bathroom,\n" +
                "flat-screen TV,\n" +
                "free Wi-Fi",

        ResKey.REVIEW1_DESC to "I highly recommend this place. Very good location, about 10 minutes by car to the ski lifts in Białka Tatrzańska. Very clean room and bathroom, plus a shared kitchen fully equipped. The owners were very kind and attentive, even offering us delicious homemade cheese. There is a prepared space for storing ski equipment. This place is worth recommending!",
        ResKey.REVIEW2_DESC to "This is simply a fantastic place with very positive energy from the owners. We will return and recommend it to everyone.",
        ResKey.REVIEW3_DESC to "A calm, cozy place for relaxation. I recommend it!",
        ResKey.REVIEW4_DESC to "Clean, tidy, excellent value for money 😁…",
        ResKey.REVIEW5_DESC to "Great place to relax. Close to the thermal baths and ski slopes. Rooms are new and clean. Friendly and helpful hosts. I wholeheartedly recommend it and see you next time.",
        ResKey.REVIEW6_DESC to "New, clean rooms in the Skwarek guest house. Well-equipped kitchen and very nice atmosphere. The owners are very friendly, I recommend it.",
        ResKey.REVIEW7_DESC to "Thank you very much for the stay. We had a wonderful time. The room was clean and tidy. The kitchen was spacious and fully equipped (microwave, fridge, stove, etc.). The hostess was super friendly and very helpful ;)",
        ResKey.REVIEW8_DESC to "I highly recommend this place. Very hospitable hostess and surprisingly high standard of rooms. Almost everything is new and fresh. Highly recommended!",
        ResKey.REVIEW9_DESC to "Hello, I recommend staying at Skwarek. Friendly owners and new rooms with bathrooms. Also, a well-equipped kitchen. Nowa Biała is a quiet town near Białka and Bukowina Tatrzańska. Close to the Tatra mountains by car. Recommended.",
        ResKey.REVIEW10_DESC to "Wonderful hosts, excellent accommodation, beautiful surroundings for hiking and cycling. Highly recommended ❤",
        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "Google reviews",


        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Bania Thermal Baths",
        ResKey.NEARBY3 to "Niedzica Castle",

        ResKey.FACILITY1 to "Free parking",
        ResKey.FACILITY2 to "Private bathroom",
        ResKey.FACILITY3 to "Free Wi-Fi",
        ResKey.FACILITY4 to "Family rooms",
        ResKey.FACILITY5 to "Shared kitchen",
        ResKey.FACILITY6 to "Fire pit",
        ResKey.FACILITY7 to "Board games / puzzles",
        ResKey.FACILITY8 to "Heating",
        ResKey.FACILITY9 to "Garden furniture",

        ResKey.FAQ1_Q to "What are the check-in and check-out times at Skwarek Guest Rooms?",
        ResKey.FAQ1_A to "Check-in starts at 16:00, and check-out is until 11:00.",
        ResKey.FAQ2_Q to "Is parking available on-site?",
        ResKey.FAQ2_A to "Free private parking is available on-site (no reservation required).",
        ResKey.FAQ3_Q to "How far is the Skwarek Guesthouse from the Kotelnica ski resort?",
        ResKey.FAQ3_A to "The Skwarek Guesthouse is 8.5 km from the Kotelnica ski resort.",
        ResKey.FAQ4_Q to "Is there a restaurant on-site?",
        ResKey.FAQ4_A to "Unfortunately, there is no restaurant at Skwarek Guest Rooms.",
        ResKey.FAQ5_Q to "Can I bring a pet?",
        ResKey.FAQ5_A to "Pets are not allowed at Skwarek Guest Rooms."
    ),


    Language.PL to mapOf(
        ResKey.ADDRESS to "8.5km od Kotelnicy w Białce Tatrzańskiej",
        ResKey.SECTION_ROOMS to "Pokoje",
        ResKey.SECTION_NEARBY to "Okolica",
        ResKey.SECTION_FACILITIES to "Udogodnienia",
        ResKey.SECTION_REVIEWS to "Opinie",
        ResKey.SECTION_FAQ to "FAQ",
        ResKey.SECTION_CONTACT to "Kontakt",
        ResKey.MAP_DIRECTION to "Zobacz na mapie",
        ResKey.BOOKING to "Zarezerwuj pokój",
        ResKey.ROOM1 to "Pokój dwuosobowy z balkonem",
        ResKey.ROOM1_DESC to "Powierzchnia 17 m², 1 łóżko podwójne. Balkon, \n" +
                "widok na ogród, \n" +
                "prywatna łazienka, \n" +
                "telewizor z płaskim ekranem, \n" +
                "bezpłatne Wi-Fi",
        ResKey.ROOM2 to "Pokój trzyosobowy z balkonem",
        ResKey.ROOM2_DESC to "Powierzchnia 19 m², 1 łóżko pojedyncze i 1 łóżko podwójne. Balkon, \n" +
                "widok na ogród, \n" +
                "prywatna łazienka, \n" +
                "telewizor z płaskim ekranem, \n" +
                "bezpłatne Wi-Fi",
        ResKey.ROOM3 to "Pokój czteroosobowy",
        ResKey.ROOM3_DESC to "Powierzchnia 22 m², 2 łóżka pojedyncze i 1 łóżko podwójne. " +
                "Widok na ogród, \n" +
                "prywatna łazienka, \n" +
                "telewizor z płaskim ekranem, \n" +
                "bezpłatne Wi-Fi",

        ResKey.REVIEW1_DESC to "Serdecznie polecam to miejsce. Bardzo dobra lokalizacja obiektu, ok. 10 minut samochodem do wyciągów narciarskich w Białce Tatrzańskiej. Bardzo czysty pokój i łazienka oraz ogólnodistępna kuchnia z pełnym wyposażeniem to atuty tego miejsca. Przemili i uprzejmi właściciele, którzy czuwali nad tym, aby niczego nam nie brakowało, poczęstowano nas nawet pysznym serem wlasnej produkcji. Przygotowane miejsce do przechowania sprzętu narciarskiego. To miejsce godne polecenia!",
        ResKey.REVIEW2_DESC to "To po prostu fantastyczne miejsce, z bardzo dobrą energią właścicieli, do którego będziemy wracać i każdemu polecamy.",
        ResKey.REVIEW3_DESC to "Spokojne, przytulne miejsce na wypoczynek. Polecam!",
        ResKey.REVIEW4_DESC to "Czysto ,schludnie , stosunek ceny do jakości wzorowy\uD83D\uDE01…",
        ResKey.REVIEW5_DESC to "Super miejsce na odpoczynek. Niedaleko termy i stoki. Pokoje nowe czyste . Gospodarze mili i pomocni. Polecam z całego serca i do zobaczenia.",
        ResKey.REVIEW6_DESC to "Nowe, czyste pokoje w domu gościnnym Skwarek. Dobrze wyposażona kuchnia i bardzo miła atmosfera. Właściciele bardzo sympatyczni, polecam.",
        ResKey.REVIEW7_DESC to "Ślicznie dziękujemy za pobyt .Spędziliśmy u państwa wspaniały czas. Pokój czysty zadbany Kuchnia przestronna wyposażona we wszystkie niezbędne sprzęty (mikrofala, lodówka, kuchenka itp) Gospodyni przesympatyczna i bardzo pomocna;)",
        ResKey.REVIEW8_DESC to "Bardzo polecam to miejsce. Bardzo gościnna gospodyni i zadziwiająco dobry standard pokoi. W zasadzie wszytko nowe i pachnące. Gorąco polecam!",
        ResKey.REVIEW9_DESC to "Witam, polecam noclegi u Skwarka. Mili właściciele i nowe pokoje z łazienkami. Poza tym dobrze wyposażona kuchnia. Nowa Biała to spokojna miejscowość w okolicy Białki i Bukowiny Tatrzańskiej. Blisko samochodem do tatr. Polecam.",
        ResKey.REVIEW10_DESC to "Wspaniali gospodarze,znakomite warunki zakwaterowania ,piękna okolica na piesze i rowerowe wyprawy. Serdecznie polecam ❤\uFE0F",
        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "opinie google",

        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Termy Bania",
        ResKey.NEARBY3 to "Zamek w Niedzicy",


        ResKey.FACILITY1 to "Bezpłatny parking",
        ResKey.FACILITY2 to "Prywatna łazienka",
        ResKey.FACILITY3 to "Bezpłatne Wi-Fi",
        ResKey.FACILITY4 to "Pokoje rodzinne",
        ResKey.FACILITY5 to "Wspólna kuchnia",
        ResKey.FACILITY6 to "Miejsce na ognisko",
        ResKey.FACILITY7 to "Gry planszowe / puzzle",
        ResKey.FACILITY8 to "Ogrzewanie",
        ResKey.FACILITY9 to "Meble ogrodowe",


        ResKey.FAQ1_Q to "Jakie są godziny zameldowania i wymeldowania w obiekcie Pokoje gościnne Skwarek?",
        ResKey.FAQ1_A to "Zameldowanie w obiekcie Pokoje gościnne Skwarek rozpoczyna się o 16:00, a wymeldować się można do 11:00.",
        ResKey.FAQ2_Q to "Czy na miejscu jest parking?",
        ResKey.FAQ2_A to "Bezpłatny parking prywatny jest dostępny na miejscu (nie jest konieczna rezerwacja).",
        ResKey.FAQ3_Q to "Jak daleko obiekt Pokoje gościnne Skwarek znajduje się od ośrodka narciarskiego Kotelnica?",
        ResKey.FAQ3_A to "Pokoje gościnne Skwarek znajdują się 8,5 km od ośrodka narciarskiego Kotelnica.",
        ResKey.FAQ4_Q to "Czy na miejscu jest restauracja?",
        ResKey.FAQ4_A to "Niestety, w obiekcie Pokoje gościnne Skwarek nie ma restauracji.",
        ResKey.FAQ5_Q to "Czy mogę przyjechać ze zwierzęciem?",
        ResKey.FAQ5_A to "Zwierzęta nie są akceptowane w obiekcie Pokoje gościnne Skwarek.",

        ),

    Language.RO to mapOf(
        ResKey.ADDRESS to "8,5 km de stațiunea Kotelnica în Białka Tatrzańska",
        ResKey.SECTION_ROOMS to "Camere",
        ResKey.SECTION_NEARBY to "Împrejurimi",
        ResKey.SECTION_FACILITIES to "Facilități",
        ResKey.SECTION_REVIEWS to "Recenzii",
        ResKey.SECTION_FAQ to "Întrebări frecvente",
        ResKey.SECTION_CONTACT to "Contact",
        ResKey.MAP_DIRECTION to "Vezi pe hartă",
        ResKey.BOOKING to "Rezervă o cameră",

        ResKey.ROOM1 to "Cameră dublă cu balcon",
        ResKey.ROOM1_DESC to "Suprafață 17 m², 1 pat dublu. Balcon, \n" +
                "vedere la grădină, \n" +
                "baie privată, \n" +
                "TV cu ecran plat, \n" +
                "Wi-Fi gratuit",

        ResKey.ROOM2 to "Cameră triplă cu balcon",
        ResKey.ROOM2_DESC to "Suprafață 19 m², 1 pat simplu și 1 pat dublu. Balcon, \n" +
                "vedere la grădină, \n" +
                "baie privată, \n" +
                "TV cu ecran plat, \n" +
                "Wi-Fi gratuit",

        ResKey.ROOM3 to "Cameră cvadruplă",
        ResKey.ROOM3_DESC to "Suprafață 22 m², 2 paturi simple și 1 pat dublu. " +
                "Vedere la grădină, \n" +
                "baie privată, \n" +
                "TV cu ecran plat, \n" +
                "Wi-Fi gratuit",

        ResKey.REVIEW1_DESC to "Recomand cu căldură acest loc. Locație foarte bună, la aproximativ 10 minute cu mașina de pârtiile de schi din Białka Tatrzańska. Camera și baia foarte curate, iar bucătăria comună complet utilată sunt mari avantaje. Proprietari extrem de amabili și atenți, care s-au asigurat că nu ne lipsește nimic — ne-au servit chiar și cu un delicios caș produs de ei. Există și spațiu pentru depozitarea echipamentului de schi. Un loc care merită recomandat!",
        ResKey.REVIEW2_DESC to "Este pur și simplu un loc fantastic, cu o energie foarte bună din partea proprietarilor. Cu siguranță vom reveni și îl recomandăm tuturor.",
        ResKey.REVIEW3_DESC to "Un loc liniștit și primitor pentru relaxare. Recomand!",
        ResKey.REVIEW4_DESC to "Curat, îngrijit, raport calitate-preț excelent 😁…",
        ResKey.REVIEW5_DESC to "Un loc excelent pentru odihnă. Aproape de băi termale și pârtii. Camere noi și curate. Gazde amabile și de ajutor. Recomand din toată inima și pe curând.",
        ResKey.REVIEW6_DESC to "Camere noi și curate în pensiunea Skwarek. Bucătărie bine echipată și o atmosferă foarte plăcută. Proprietari foarte simpatici, recomand.",
        ResKey.REVIEW7_DESC to "Vă mulțumim foarte mult pentru ședere. Am petrecut un timp minunat la dumneavoastră. Cameră curată și bine întreținută. Bucătărie spațioasă, dotată cu toate echipamentele necesare (microunde, frigider, aragaz etc.). Gazda extrem de prietenoasă și foarte de ajutor ;)",
        ResKey.REVIEW8_DESC to "Recomand cu mare drag acest loc. Gazdă foarte primitoare și un standard surprinzător de bun al camerelor. Practic totul este nou și impecabil. Recomand cu căldură!",
        ResKey.REVIEW9_DESC to "Salut, recomand cazarea la Skwarek. Proprietari amabili și camere noi cu băi proprii. De asemenea, bucătărie bine echipată. Nowa Biała este o localitate liniștită, aproape de Białka și Bukowina Tatrzańska. Aproape de Munții Tatra cu mașina. Recomand.",
        ResKey.REVIEW10_DESC to "Gazde minunate, condiții excelente de cazare, zonă frumoasă pentru drumeții și plimbări cu bicicleta. Recomand cu sinceritate ❤️",

        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "recenzii Google",

        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Băile Termale Bania",
        ResKey.NEARBY3 to "Castelul Niedzica",

        ResKey.FACILITY1 to "Parcare gratuită",
        ResKey.FACILITY2 to "Baie privată",
        ResKey.FACILITY3 to "Wi-Fi gratuit",
        ResKey.FACILITY4 to "Camere de familie",
        ResKey.FACILITY5 to "Bucătărie comună",
        ResKey.FACILITY6 to "Loc pentru foc de tabără",
        ResKey.FACILITY7 to "Jocuri de societate / puzzle-uri",
        ResKey.FACILITY8 to "Încălzire",
        ResKey.FACILITY9 to "Mobilier de grădină",

        ResKey.FAQ1_Q to "Care sunt orele de check-in și check-out la Pokoje gościnne Skwarek?",
        ResKey.FAQ1_A to "Check-in-ul la Pokoje gościnne Skwarek începe la ora 16:00, iar check-out-ul se face până la ora 11:00.",
        ResKey.FAQ2_Q to "Există parcare la proprietate?",
        ResKey.FAQ2_A to "Parcarea privată gratuită este disponibilă la fața locului (nu este necesară rezervare).",
        ResKey.FAQ3_Q to "Cât de departe se află Pensiunea Skwarek de stațiunea de schi Kotelnica?",
        ResKey.FAQ3_A to "Pensiunea Skwarek se află la 8,5 km de stațiunea de schi Kotelnica.",
        ResKey.FAQ4_Q to "Există restaurant la proprietate?",
        ResKey.FAQ4_A to "Din păcate, Pokoje gościnne Skwarek nu dispune de restaurant.",
        ResKey.FAQ5_Q to "Pot veni cu un animal de companie?",
        ResKey.FAQ5_A to "Animalele de companie nu sunt acceptate la Pokoje gościnne Skwarek.",),

    Language.CS to mapOf(
        ResKey.ADDRESS to "8,5 km od Kotelnice v Białce Tatrzańské",
        ResKey.SECTION_ROOMS to "Pokoje",
        ResKey.SECTION_NEARBY to "Okolí",
        ResKey.SECTION_FACILITIES to "Vybavení",
        ResKey.SECTION_REVIEWS to "Recenze",
        ResKey.SECTION_FAQ to "FAQ",
        ResKey.SECTION_CONTACT to "Kontakt",
        ResKey.MAP_DIRECTION to "Zobrazit na mapě",
        ResKey.BOOKING to "Rezervovat pokoj",

        ResKey.ROOM1 to "Dvoulůžkový pokoj s balkonem",
        ResKey.ROOM1_DESC to "Plocha 17 m², 1 manželská postel. Balkon, \n" +
                "výhled do zahrady, \n" +
                "vlastní koupelna, \n" +
                "TV s plochou obrazovkou, \n" +
                "Wi-Fi zdarma",

        ResKey.ROOM2 to "Třílůžkový pokoj s balkonem",
        ResKey.ROOM2_DESC to "Plocha 19 m², 1 jednolůžko a 1 manželská postel. Balkon, \n" +
                "výhled do zahrady, \n" +
                "vlastní koupelna, \n" +
                "TV s plochou obrazovkou, \n" +
                "Wi-Fi zdarma",

        ResKey.ROOM3 to "Čtyřlůžkový pokoj",
        ResKey.ROOM3_DESC to "Plocha 22 m², 2 jednolůžka a 1 manželská postel. " +
                "Výhled do zahrady, \n" +
                "vlastní koupelna, \n" +
                "TV s plochou obrazovkou, \n" +
                "Wi-Fi zdarma",

        ResKey.REVIEW1_DESC to "Toto místo vřele doporučuji. Velmi dobrá poloha objektu, cca 10 minut autem k lyžařským vlekům v Białce Tatrzańské. Velmi čistý pokoj i koupelna a společná kuchyně plně vybavená jsou velkými přednostmi tohoto místa. Velmi milí a ochotní majitelé, kteří dbali na to, aby nám nic nechybělo — dokonce nás pohostili vynikajícím domácím sýrem. K dispozici je i místo pro uložení lyžařského vybavení. Místo hodné doporučení!",
        ResKey.REVIEW2_DESC to "Je to prostě fantastické místo s velmi dobrou energií majitelů. Určitě se sem budeme vracet a všem doporučujeme.",
        ResKey.REVIEW3_DESC to "Klidné, útulné místo k odpočinku. Doporučuji!",
        ResKey.REVIEW4_DESC to "Čisto, uklizeno, poměr ceny a kvality naprosto perfektní 😁…",
        ResKey.REVIEW5_DESC to "Skvělé místo k odpočinku. Nedaleko termální lázně a sjezdovky. Pokoje nové a čisté. Majitelé milí a ochotní. Doporučuji z celého srdce a brzy na viděnou.",
        ResKey.REVIEW6_DESC to "Nové, čisté pokoje v penzionu Skwarek. Dobře vybavená kuchyně a velmi příjemná atmosféra. Majitelé velmi sympatičtí, doporučuji.",
        ResKey.REVIEW7_DESC to "Moc děkujeme za pobyt. Strávili jsme u vás nádherný čas. Pokoj čistý a pečlivě udržovaný. Kuchyně prostorná, vybavená veškerými potřebnými spotřebiči (mikrovlnná trouba, lednice, sporák apod.). Paní domácí velmi milá a ochotná ;)",
        ResKey.REVIEW8_DESC to "Velmi doporučuji toto místo. Velmi pohostinná paní domácí a překvapivě vysoký standard pokojů. V podstatě vše nové a voňavé. Vřele doporučuji!",
        ResKey.REVIEW9_DESC to "Dobrý den, doporučuji ubytování u Skwarka. Milí majitelé a nové pokoje s vlastními koupelnami. K tomu dobře vybavená kuchyně. Nowa Biała je klidná obec v okolí Białky a Bukowiny Tatrzańské. Autem blízko do Tater. Doporučuji.",
        ResKey.REVIEW10_DESC to "Skvělí hostitelé, výborné podmínky ubytování, krásné okolí pro pěší i cyklistické výlety. Vřele doporučuji ❤️",

        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "recenze Google",

        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Termální lázně Bania",
        ResKey.NEARBY3 to "Hrad Niedzica",

        ResKey.FACILITY1 to "Parkování zdarma",
        ResKey.FACILITY2 to "Vlastní koupelna",
        ResKey.FACILITY3 to "Wi-Fi zdarma",
        ResKey.FACILITY4 to "Rodinné pokoje",
        ResKey.FACILITY5 to "Společná kuchyně",
        ResKey.FACILITY6 to "Místo pro ohniště",
        ResKey.FACILITY7 to "Stolní hry / puzzle",
        ResKey.FACILITY8 to "Topení",
        ResKey.FACILITY9 to "Zahradní nábytek",

        ResKey.FAQ1_Q to "Jaké jsou časy check-inu a check-outu v objektu Pokoje gościnne Skwarek?",
        ResKey.FAQ1_A to "Check-in v objektu Pokoje gościnne Skwarek začíná v 16:00 a check-out je možný do 11:00.",
        ResKey.FAQ2_Q to "Je na místě k dispozici parkování?",
        ResKey.FAQ2_A to "Soukromé parkování zdarma je k dispozici na místě (rezervace není nutná).",
        ResKey.FAQ3_Q to "Jak daleko je Penzion Skwarek od lyžařského střediska Kotelnica?",
        ResKey.FAQ3_A to "Penzion Skwarek je vzdálený 8,5 km od lyžařského střediska Kotelnica.",
        ResKey.FAQ4_Q to "Je v objektu restaurace?",
        ResKey.FAQ4_A to "Bohužel se v objektu Pokoje gościnne Skwarek nenachází restaurace.",
        ResKey.FAQ5_Q to "Mohu přijet s domácím mazlíčkem?",
        ResKey.FAQ5_A to "Domácí mazlíčci nejsou v objektu Pokoje gościnne Skwarek povoleni.",),

    Language.HU to mapOf(
        ResKey.ADDRESS to "8,5 km-re a Kotelnica síközponttól, Białka Tatrzańskában",
        ResKey.SECTION_ROOMS to "Szobák",
        ResKey.SECTION_NEARBY to "Környék",
        ResKey.SECTION_FACILITIES to "Felszereltség",
        ResKey.SECTION_REVIEWS to "Vélemények",
        ResKey.SECTION_FAQ to "GYIK",
        ResKey.SECTION_CONTACT to "Kapcsolat",
        ResKey.MAP_DIRECTION to "Megtekintés a térképen",
        ResKey.BOOKING to "Szoba foglalása",
        ResKey.ROOM1 to "Kétágyas szoba erkéllyel",
        ResKey.ROOM1_DESC to "Terület: 17 m², 1 franciaágy. Erkély, \n" +
                "kertre néző kilátás, \n" +
                "saját fürdőszoba, \n" +
                "lapos képernyős TV, \n" +
                "ingyenes Wi-Fi",
        ResKey.ROOM2 to "Háromágyas szoba erkéllyel",
        ResKey.ROOM2_DESC to "Terület: 19 m², 1 egyszemélyes ágy és 1 franciaágy. Erkély, \n" +
                "kertre néző kilátás, \n" +
                "saját fürdőszoba, \n" +
                "lapos képernyős TV, \n" +
                "ingyenes Wi-Fi",
        ResKey.ROOM3 to "Négyágyas szoba",
        ResKey.ROOM3_DESC to "Terület: 22 m², 2 egyszemélyes ágy és 1 franciaágy. \n" +
                "Kertre néző kilátás, \n" +
                "saját fürdőszoba, \n" +
                "lapos képernyős TV, \n" +
                "ingyenes Wi-Fi",

        ResKey.REVIEW1_DESC to "Őszintén ajánlom ezt a helyet. Nagyon jó elhelyezkedés, kb. 10 perc autóval a Białka Tatrzańska sífelvonóihoz. Nagyon tiszta szoba és fürdőszoba, valamint jól felszerelt közös konyha. Kedves és udvarias tulajdonosok, akik gondoskodtak arról, hogy semmiben ne szenvedjünk hiányt, még saját készítésű sajttal is megkínáltak. Külön hely a sífelszerelés tárolására. Nagyon ajánlom!",
        ResKey.REVIEW2_DESC to "Egyszerűen fantasztikus hely, a tulajdonosok nagyon jó energiával rendelkeznek, ahová vissza fogunk térni, mindenkinek ajánljuk.",
        ResKey.REVIEW3_DESC to "Nyugodt, hangulatos hely a pihenésre. Ajánlom!",
        ResKey.REVIEW4_DESC to "Tiszta, rendezett, ár-érték arány kiváló 😁…",
        ResKey.REVIEW5_DESC to "Szuper hely a pihenésre. Közel a termálfürdőkhöz és a sípályákhoz. Szobák újak és tiszták. Kedves és segítőkész vendéglátók. Szívből ajánlom, viszlát!",
        ResKey.REVIEW6_DESC to "Új, tiszta szobák a Skwarek vendégházban. Jól felszerelt konyha és nagyon barátságos légkör. A tulajdonosok nagyon kedvesek, ajánlom.",
        ResKey.REVIEW7_DESC to "Nagyon köszönjük a tartózkodást. Csodás időt töltöttünk Önöknél. Tiszta, rendezett szoba. Tágas, minden szükséges eszközzel felszerelt konyha (mikrohullámú sütő, hűtő, tűzhely stb.). A háziasszony rendkívül kedves és segítőkész ;)",
        ResKey.REVIEW8_DESC to "Nagyon ajánlom ezt a helyet. Nagyon vendégszerető háziasszony és meglepően jó szobák. Szinte minden új és illatos. Melegen ajánlom!",
        ResKey.REVIEW9_DESC to "Üdv, ajánlom a Skwarek szállását. Kedves tulajdonosok és új szobák fürdőszobával. Emellett jól felszerelt konyha. Nowa Biała nyugodt település Białka és Bukowina Tatrzańska környékén. Kocsival közel a hegyekhez. Ajánlom.",
        ResKey.REVIEW10_DESC to "Csodás vendéglátók, kiváló szállásfeltételek, gyönyörű környék gyalogos és kerékpáros túrákhoz. Szívből ajánlom ❤",
        ResKey.REVIEW_BOOKING to "booking.com",
        ResKey.REVIEW_GOOGLE to "Google vélemények",

        ResKey.NEARBY1 to "Białka Tatrzańska",
        ResKey.NEARBY2 to "Bania Termálfürdő",
        ResKey.NEARBY3 to "Niedzica vára",

        ResKey.FACILITY1 to "Ingyenes parkolás",
        ResKey.FACILITY2 to "Saját fürdőszoba",
        ResKey.FACILITY3 to "Ingyenes Wi-Fi",
        ResKey.FACILITY4 to "Családi szobák",
        ResKey.FACILITY5 to "Közös konyha",
        ResKey.FACILITY6 to "Tűzrakóhely",
        ResKey.FACILITY7 to "Társasjátékok / puzzle",
        ResKey.FACILITY8 to "Fűtés",
        ResKey.FACILITY9 to "Kerti bútor",

        ResKey.FAQ1_Q to "Mik a be- és kijelentkezés időpontjai a Skwarek Vendégházban?",
        ResKey.FAQ1_A to "A bejelentkezés 16:00 órától lehetséges, a kijelentkezés 11:00 óráig.",
        ResKey.FAQ2_Q to "Van parkolási lehetőség a helyszínen?",
        ResKey.FAQ2_A to "Ingyenes privát parkoló áll rendelkezésre a helyszínen (foglalás nem szükséges).",
        ResKey.FAQ3_Q to "Milyen messze van a Skwarek Vendégház a Kotelnica síközponttól?",
        ResKey.FAQ3_A to "A Skwarek Vendégház 8,5 km-re található a Kotelnica síközponttól.",
        ResKey.FAQ4_Q to "Van étterem a helyszínen?",
        ResKey.FAQ4_A to "Sajnos a Skwarek Vendégházban nincs étterem.",
        ResKey.FAQ5_Q to "Hozhatok állatot?",
        ResKey.FAQ5_A to "Az állatokat nem fogadják el a Skwarek Vendégházban."

    )
)


data class LanguageContext(
    val lang: Language,
    val setLang: (Language) -> Unit
)

// Create the CompositionLocal. It needs a default value.
val LocalLanguage = compositionLocalOf {
    LanguageContext(
        lang = Language.PL,
        setLang = {},
    )
}

@Composable
fun LocalText(key: ResKey?): String {
    return TextResources[LocalLanguage.current.lang]?.get(key).orEmpty()
}